"use strict";
// (C) 2022-2023 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.cancelEditRenderMode = exports.switchToEditRenderMode = exports.changeRenderMode = void 0;
/**
 * Creates the ChangeRenderMode command. Dispatching this command will result in change of the render mode of dashboard component
 *
 * @param renderMode - render mode value
 * @param renderModeChangeOptions - options for render mode change
 * @param correlationId - specify correlation id to use for this command. this will be included in all
 *  events that will be emitted during the command processing
 *
 * @beta
 */
function changeRenderMode(renderMode, renderModeChangeOptions, correlationId) {
    if (renderModeChangeOptions === void 0) { renderModeChangeOptions = { resetDashboard: true }; }
    return {
        type: "GDC.DASH/CMD.CHANGE_RENDER_MODE",
        correlationId: correlationId,
        payload: {
            renderMode: renderMode,
            renderModeChangeOptions: renderModeChangeOptions,
        },
    };
}
exports.changeRenderMode = changeRenderMode;
/**
 * Creates the ChangeRenderMode command for switch to edit mode.
 *
 * @param correlationId - specify correlation id to use for this command. this will be included in all
 *  events that will be emitted during the command processing
 *
 * @beta
 */
function switchToEditRenderMode(correlationId) {
    return changeRenderMode("edit", { resetDashboard: true }, correlationId);
}
exports.switchToEditRenderMode = switchToEditRenderMode;
/**
 * Creates the ChangeRenderMode command for cancel edit mode.
 *
 * @param correlationId - specify correlation id to use for this command. this will be included in all
 *  events that will be emitted during the command processing
 *
 * @beta
 */
function cancelEditRenderMode(correlationId) {
    return changeRenderMode("view", { resetDashboard: true }, correlationId);
}
exports.cancelEditRenderMode = cancelEditRenderMode;
//# sourceMappingURL=renderMode.js.map